import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngstack/translate';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslateModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  
  socialLinks = [
    { icon: 'twitter', url: '#', label: 'Twitter' },
    { icon: 'linkedin', url: '#', label: 'LinkedIn' },
    { icon: 'github', url: '#', label: 'GitHub' },
    { icon: 'facebook', url: '#', label: 'Facebook' }
  ];
  
  productLinks = [
    { label: 'Platform', route: '/platform' },
    { label: 'Products', route: '/products' },
    { label: 'Pricing', route: '/pricing' },
    { label: 'Blog', route: '/blog' },
    { label: 'Downloads', route: '/downloads' }
  ];
  
  companyLinks = [
    { label: 'About Us', route: '/about' },
    { label: 'Contact', route: '/contact' },
    { label: 'Careers', route: '/careers' },
    { label: 'Press', route: '/press' }
  ];
  
  legalLinks = [
    { label: 'Privacy Policy', route: '/privacy' },
    { label: 'Terms of Service', route: '/terms' },
    { label: 'Cookie Policy', route: '/cookies' },
    { label: 'Delete Account', route: '/tenant-delete-request' }
  ];
}

